module.exports = __webpack_public_path__ + "img/智能识别--人脸追踪.78eb1f38.png";